import React from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

const CandidateVisitorContent: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="web-visitor-content">
      <div className="datenschutz-container">
        <section className="datenschutz-section">
          <h2>1. {t('candidateVisitorOverview')}</h2>
          <div className="datenschutz-content">
            <h3>{t('candidateVisitorGeneral')}</h3>
            <p>{t('candidateVisitorGeneralText')}</p>
            <h3 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('candidateVisitorDataCollection')) }}></h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('candidateVisitorResponsibleText')) }}></p>
          </div>
        </section>
        <section className="datenschutz-section">
          <h2>2. {t('candidateVisitorGeneralNotes')}</h2>
          <div className="datenschutz-content">
            <h3>{t('candidateVisitorPrivacy')}</h3>
            <p>{t('candidateVisitorPrivacyText')}</p>

            <h3>{t('candidateVisitorPurpose')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('candidateVisitorPurposeText')) }}></p>
          </div>
        </section>

        <section className="datenschutz-section">
          <h2>3. {t('candidateVisitorRecipients')}</h2>
          <div className="datenschutz-content">
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('candidateVisitorRecipientsText')) }}></p>
          </div>
        </section>

        <section className="datenschutz-section">
          <h2>4. {t('candidateVisitorYourRights')}</h2>
          <div className="datenschutz-content">
            <h3>{t('candidateVisitorWithdrawConsent')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('candidateVisitorWithdrawConsentText')) }}></p>

            <h3>{t('candidateVisitorRightToObject')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('candidateVisitorRightToObjectText')) }}></p>
            
            <h3>{t('candidateVisitorComplaintRight')}</h3>
            <p>{t('candidateVisitorComplaintRightText')}</p>
            
            <h3>{t('candidateVisitorDataPortability')}</h3>
            <p>{t('candidateVisitorDataPortabilityText')}</p>
            
            <h3>{t('candidateVisitorAccessBlockDelete')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('candidateVisitorAccessBlockDeleteText')) }}></p>
            
            <h3>{t('candidateVisitorRestrictionRight')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('candidateVisitorRestrictionRightText')) }}></p>
            
            <h3>{t('candidateVisitorObjectAdvertising')}</h3>
            <p>{t('candidateVisitorObjectAdvertisingText')}</p>
          </div>
        </section>

        <section className="datenschutz-section">
          <h2>5. {t('candidateVisitorDataProtectionOfficer')}</h2>
          <div className="datenschutz-content">
            <h3>{t('candidateVisitorStatutoryOfficer')}</h3>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('candidateVisitorStatutoryOfficerText')) }}></p>
          </div>
        </section>

        <section className="datenschutz-section">
          <h2>6. {t('candidateVisitorFurtherInfo')}</h2>
          <div className="datenschutz-content">
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('candidateVisitorFurtherInfoText')) }}></p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CandidateVisitorContent;
